import {
  RESET_SEARCH_PAGE_COMPONENTS,
  RESET_SELECTED_TXNS,
  SET_SELECTED_TXNS,
  SET_SELECTED_TXN_STATUS,
  SET_TABLE_VISIBILITY,
} from "../action";
import { searchPageComponents } from "./initial-store";

const initialState = searchPageComponents;

function setSearchPageComponentReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_TXNS:
      const selectedTxnValue = action.payload;
      if (Array.isArray(selectedTxnValue)) {
        return { ...state, selectedTransactions: selectedTxnValue };
      } else {
        return { ...state, selectedTransactions: [selectedTxnValue] };
      }
    case SET_TABLE_VISIBILITY:
      return { ...state, isTableVisible: action.payload };
    case SET_SELECTED_TXN_STATUS:
      return { ...state, selectedTxnStatus: action.payload };
    case RESET_SELECTED_TXNS:
      return { ...state, selectedTransactions: [] };
    case RESET_SEARCH_PAGE_COMPONENTS:
      return {
        ...state,
        selectedTransactions: [],
        isTableVisible: false,
        selectedTxnStatus: false,
      };
    default:
      return state;
  }
}

export default setSearchPageComponentReducer;
